module.exports = __webpack_public_path__ + "img/messageCenter.b42b151a.png";